

import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/usuarios/auth.store";




export const PrivateRoute2 = ({ children }) => {


    const authStatus = useAuthStore(state => state.status);



    return authStatus === 'authorized' 
        ? children 
        : <Navigate to="/admin/login" replace />;
}
